import { render, staticRenderFns } from "./IndexRealTimeCount.vue?vue&type=template&id=193bcc48&scoped=true&"
import script from "./IndexRealTimeCount.vue?vue&type=script&lang=js&"
export * from "./IndexRealTimeCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bcc48",
  null
  
)

export default component.exports